export const ANNOTATION_SYMBOLS = [
  // [startTag, endTag]
  ['\uF050', '\uF051'],
  ['\uF052', '\uF053'],
  ['\uF054', '\uF055'],
  ['\uF056', '\uF057'],
  ['\uF058', '\uF059'],
  ['\uF05A', '\uF05B'],
  ['\uF05C', '\uF05D'],
  ['\uF05F', '\uF060'],
  ['\uF061', '\uF062'],
  ['\uF063', '\uF064'],
  ['\uF065', '\uF066'],
  ['\uF067', '\uF068'],
  ['\uF069', '\uF06A'],
  ['\uF06B', '\uF06C'],
  ['\uF06E', '\uF06F'],
  ['\uF070', '\uF071'],
  ['\uF072', '\uF073'],
  ['\uF074', '\uF075'],
  ['\uF076', '\uF077'],
  ['\uF078', '\uF079'],
  ['\uF07A', '\uF07B'],
  ['\uF07C', '\uF07D'],
  ['\uF07E', '\uF07F'],
  ['\uF080', '\uF081'],
  ['\uF082', '\uF083'],
  ['\uF084', '\uF085'],
  ['\uF086', '\uF087'],
  ['\uF088', '\uF089'],
  ['\uF08A', '\uF08B'],
  ['\uF08C', '\uF08D'],
  ['\uF08E', '\uF08F'],
]

export const CHILD_SYMBOL = '\uF0D0'

export const DECORATOR_SYMBOLS = [
  // [startTag, endTag]
  ['\uF000', '\uF001'],
  ['\uF002', '\uF003'],
  ['\uF004', '\uF005'],
  ['\uF006', '\uF007'],
  ['\uF008', '\uF009'],
  ['\uF00A', '\uF00B'],
  ['\uF00C', '\uF00D'],
  ['\uF00F', '\uF010'],
  ['\uF011', '\uF012'],
  ['\uF013', '\uF014'],
  ['\uF015', '\uF016'],
  ['\uF017', '\uF018'],
  ['\uF019', '\uF01A'],
  ['\uF01B', '\uF01C'],
  ['\uF01E', '\uF01F'],
  ['\uF020', '\uF021'],
]

export const EMPTY_BLOCK_SYMBOL = '\u21B2'

export const INLINE_SYMBOLS = [
  '\uF090',
  '\uF091',
  '\uF092',
  '\uF093',
  '\uF094',
  '\uF095',
  '\uF096',
  '\uF097',
  '\uF098',
  '\uF099',
  '\uF09A',
  '\uF09B',
  '\uF09C',
  '\uF09D',
  '\uF09E',
  '\uF09F',
  '\uF0A0',
  '\uF0A1',
  '\uF0A2',
  '\uF0A3',
  '\uF0A4',
  '\uF0A5',
  '\uF0A6',
  '\uF0A7',
  '\uF0A8',
  '\uF0A9',
  '\uF0AA',
  '\uF0AB',
  '\uF0AC',
  '\uF0AD',
  '\uF0AE',
  '\uF0AF',
  '\uF0B0',
  '\uF0B1',
  '\uF0B2',
  '\uF0B3',
  '\uF0B4',
  '\uF0B5',
  '\uF0B6',
  '\uF0B7',
  '\uF0B8',
  '\uF0B9',
  '\uF0BA',
  '\uF0BB',
  '\uF0BC',
  '\uF0BD',
  '\uF0BE',
  '\uF0BF',
]

export const TRAILING_SPACE_SYMBOL = '\u205F'

export const SEGMENT_START_SYMBOL = '\u2060'
